<template>
    <div class="benefits">
        <h3 class="benefits__title">Solutiile GIROS COMPANY</h3>
        <h5 class="benefits__subtitle">va ofera urmatoarele beneficii:</h5>
        <div class="row benefits-container">
            <div class="col-12 col-sm-6 col-md-4" v-for="(benefit, index) in benefits" :key="index">
                <div class="benefit">
                    <h2 class="benefit__title"> {{benefit.title}} </h2>
                    <div class="benefit__text" v-html="benefit.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        },
        props: ['benefits']
    }
</script>

<style scoped>

</style>


